import { MantineProvider } from '@mantine/core';
import { DatesProvider } from '@mantine/dates';

import { ProjectContext } from '#core/contexts/ProjectContext.ts';
import { type ProjectConfigInput, ProjectConfigSchema } from '#core/schema/ProjectConfigSchema.ts';

export interface ProjectProviderProps<ConfigType extends ProjectConfigInput> {
  config: ConfigType;
}

export function ProjectProvider<const ConfigType extends ProjectConfigInput>({
  children,
  config: inputConfig,
}: React.PropsWithChildren<ProjectProviderProps<ConfigType>>) {
  const config = ProjectConfigSchema.parse(inputConfig);
  return (
    // @ts-expect-error - Config type is inferred from app's module augmentation
    <ProjectContext value={{ config }}>
      <MantineProvider
        defaultColorScheme={config?.defaultColorScheme}
        forceColorScheme={config?.forceColorScheme}
        theme={config?.theme}
      >
        <DatesProvider settings={{ locale: 'en', consistentWeeks: true }}>{children}</DatesProvider>
      </MantineProvider>
    </ProjectContext>
  );
}
